import React, { Component } from 'react';
import { SelectSkeleton, RadioButton } from 'carbon-components-react';
import Select from 'react-select';
import { getDmService, getByDmService } from '../../services/Api';

class MessagesModels extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      models: [],
      selectedCategory: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    this.loadCategories();
  }

  loadCategories = async () => {
    const { type } = this.props;
    try {
      const data = await getDmService(`/ModeloCategoria/GetByTipo?tipo=${type}`);
      this.setState({ categories: data, isLoading: false });
    } catch (e) {
      this.setState({ isLoading: false });
    }
  };

  onCategoryChange = async (value) => {
    try {
      const data = await getByDmService('/Modelo/GetByCategoria', value.id);
      this.setState({ models: data, selectedCategory: value });
    } catch (e) {
      console.log(e);
    }
  };

  renderModels = () => {
    const { models, selectedCategory } = this.state;
    const { onChangeModel } = this.props;

    if (!models.length && selectedCategory) {
      return (
        <p className="font-size-12">
          Não existem modelos de mensagem cadastrados para esta categoria
        </p>
      );
    }

    if (!models.length) return null;

    return models.map(item => (
      <div key={item.id}>
        <div className="bx--form-item with-border box-msg-alternativ">
          <RadioButton
            name="message-model"
            onChange={onChangeModel}
            value={item.descricao}
            labelText={item.descricao}
          />
        </div>
      </div>
    ));
  };

  render() {
    const { categories, selectedCategory, isLoading } = this.state;

    if (isLoading) {
      return (
        <div>
          <div className="v-lg-margin">
            <SelectSkeleton />
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="v-lg-margin">
          <label>Selecione a categoria desejada</label>

          <Select
            className="v-md-margin"
            options={categories.map(item => ({ id: item.id, label: item.nome }))}
            value={selectedCategory}
            onChange={this.onCategoryChange}
            placeholder="Selecione uma categoria"
          />
        </div>

        {this.renderModels()}
      </div>
    );
  }
}

export default MessagesModels;



// WEBPACK FOOTER //
// ./src/components/campaigns/MessagesModels.js